// Set webpack public path
__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content

import {HadronCollider} from "@webreact/webreactor"

const router = new HadronCollider([
    {
        target: "#footer-outer",
        file: async () => (await import("./components/global/footer")).default,
    },
    {
        target: ".swiper-custom",
        file: async () => (await import("./components/swiper")).default,
    },
    {
        target: "lottie-player",
        file: async () => (await import("./components/lottie")).default,
    },
    {
        target: ".intro",
        file: async () => (await import("./components/intro")).default,
    },
    {
        file: (async () => (await (import('./components/plyr'))).default),
        target: '.js-plyr'
    },
    {
        file: (async () => (await (import('./components/appointment'))).default),
        target: '.appointment'
    },
    {
        file: (async () => (await (import('./components/modal'))).default),
        target: '.modal'
    },
    {
        file: (async () => (await (import('./components/activecampaign'))).default),
        target: '.form__activecampaign'
    },
    {
        file: (async () => (await (import('./components/wc-quantity'))).default),
        target: '.quantity'
    },
    {
        file: (async () => (await (import('./components/filter-button'))).default),
        target: '.filter-button'
    },
    {
        file: (async () => (await (import('./components/sidebar'))).default),
        target: '#sidebar'
    },
    {
        file: (async () => (await (import('./helpers/video-helper'))).default),
        target: '.page-header__video'
    },
])

router.run()